export const REGISTERATION_START = 'REGISTERATION_START'
export const REGISTERATION_SUCCESS = 'REGISTERATION_SUCCESS'
export const REGISTERATION_DUPLICATE = 'REGISTERATION_DUPLICATE'
export const REGISTERATION_FAIL = 'REGISTERATION_FAIL'

export const VALIDATION_START = 'VALIDATION_START'
export const VALIDATION_SUCCESS = 'VALIDATION_SUCCESS'
export const VALIDATION_FAIL = 'VALIDATION_FAIL'

export const GET_PROFILE_START = 'GET_PROFILE_START'
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL'

export const GET_PLAN_PROFILE_START = 'GET_PLAN_PROFILE_START'
export const GET_PLAN_PROFILE_SUCCESS = 'GET_PLAN_PROFILE_SUCCESS'
export const GET_PLAN_PROFILE_FAIL = 'GET_PLAN_PROFILE_FAIL'

export const UPLOAD_PROFILE_START = 'UPLOAD_PROFILE_START'
export const UPLOAD_PROFILE_SUCCESS = 'UPLOAD_PROFILE_SUCCESS'
export const UPLOAD_PROFILE_FAIL = 'UPLOAD_PROFILE_FAIL'

export const CHANGE_NAME_START = 'CHANGE_NAME_START'
export const CHANGE_NAME_SUCCESS = 'CHANGE_NAME_SUCCESS'
export const CHANGE_NAME_FAIL = 'CHANGE_NAME_FAIL'

export const UPLOAD_PLAN_START = 'UPLOAD_PLAN_START'
export const UPLOAD_PLAN_SUCCESS = 'UPLOAD_PLAN_SUCCESS'
export const UPLOAD_PLAN_FAIL = 'UPLOAD_PLAN_FAIL'
